// 扩展 el-input 组件，支持指定数字格式
import { ElInput as Input } from 'element-plus'
import { watch } from 'vue'

const ElInput = {
  ...Input,
  props: {
    ...Input.props,
    isNumber: Boolean, // 是否仅能输入数字
    numberFormat: Object // 数字格式
  },
  setup(props, context) {
    // 数字类型，需做转换
    if (props.isNumber || props.numberFormat) {
      watch(
        () => props.modelValue,
        (value) => {
          const formattedValue = parseNumber(value, props.numberFormat)
          if (formattedValue !== value) {
            context.emit('update:modelValue', formattedValue)
          }
        },
        { immediate: true }
      )
    }
    return Input.setup.call(this, props, context)
  }
}

// 将字符串转成所需格式的数字
function parseNumber(value, numberFormatValue) {
  value = String(value).trim()
  // 默认数字格式
  const defaultNumberFormat = {
    decimal: true, // 是否支持小数
    maxDecimalLength: undefined, // 最大小数点位数
    maxIntegerLength: undefined, // 最大整数位数
    maxLength: undefined, // 最大长度
    negative: true, // 是否支持负数
    leadingZero: true // 是否支持前导零，如 001
  }
  const numberFormat = Object.assign(defaultNumberFormat, numberFormatValue)
  const firstDotIndex = value.indexOf('.')
  const firstMinusIndex = value.indexOf('-')
  // 小数
  if (numberFormat.decimal && firstDotIndex > -1) {
    let beforeText = value.slice(0, firstDotIndex).replace(/[^\d]/g, '')
    if (!beforeText.length) {
      beforeText = '0'
    }
    const afterText = value.slice(firstDotIndex + 1).replace(/[^\d]/g, '')
    value = `${beforeText}.${afterText}`
  } else {
    value = value.replace(/[^\d]/g, '')
  }

  // 整数
  if (
    numberFormat.maxIntegerLength &&
    value.length > numberFormat.maxIntegerLength
  ) {
    value = value.replace(/^(\d+)/g, (intText) =>
      intText.slice(0, numberFormat.maxIntegerLength)
    )
  }

  // 如果第一位存在减号，就加上
  if (firstMinusIndex === 0 && numberFormat.negative) {
    value = `-${value}`
  }

  // 禁止前导零
  if (/^-?0\d+/.test(value) && !numberFormat.leadingZero) {
    value = value.replace(/^(-?)0+(\d+)/, '$1$2')
  }

  // 小数点最大长度
  if (
    numberFormat.decimal &&
    numberFormat.maxDecimalLength &&
    firstDotIndex > -1
  ) {
    value = value.replace(/\d+$/, (decimalNumbers) =>
      decimalNumbers.slice(0, numberFormat.maxDecimalLength)
    )
  }
  // 数字最大长度
  if (numberFormat.maxLength) {
    value = value.slice(0, numberFormat.maxLength)
  }
  return value
}

export default ElInput
